import { _ as __awaiter, a as __generator, b as __assign } from '../_tslib-6fadb982.js';

// 加载ali sdk
var loadAliSdk = function () {
  var loaded = false;
  return new Promise(function (resolve, reject) {
    var sipDom = document.getElementById('aliSipScript') || document.createElement('script');
    var indexDom = document.getElementById('aliIndexScript') || document.createElement('script');
    var workbenchDom = document.getElementById('aliWorkbenchScript') || document.createElement('script');
    if (sipDom) {
      sipDom && sipDom.remove();
      indexDom && indexDom.remove();
      workbenchDom && workbenchDom.remove();
    }
    var sIPmlScript = document.createElement('script');
    var indexScript = document.createElement('script');
    var workbenchSdk = document.createElement('script');
    sIPmlScript.type = 'text/javascript';
    indexScript.type = 'text/javascript';
    workbenchSdk.type = 'text/javascript';
    sIPmlScript.id = 'aliSipScript';
    indexScript.id = 'aliIndexScript';
    workbenchSdk.id = 'aliWorkbenchScript';
    // sIPmlScript.src = `https://g.alicdn.com/cloudcallcenter/SIPml/0.1.3/SIPml-api.js`;
    indexScript.src = "https://g.alicdn.com/cloudcallcenter-voip/agentbar-sdk/2.8.7/index.js";
    workbenchSdk.src = "https://g.alicdn.com/acca/workbench-sdk/1.2.3/workbenchSdk.min.js";
    // https://g.alicdn.com/cloudcallcenter-voip/agentbar-sdk/2.8.7/index.js
    // sIPmlScript.src = 'https://gd-file.gaodun.com/call-static/SIPml-api-v2.js';
    sIPmlScript.src = 'https://g.alicdn.com/cloudcallcenter/SIPml/0.3.0/SIPml-api.js';
    // indexScript.src = `https://gd-file.gaodun.com/call-static/agentbar-sdk-v2.js`;
    // indexScript.src = `https://g.alicdn.com/cloudcallcenter-voip/agentbar-sdk/2.8.7/index.js`
    // workbenchSdk.src = `https://gd-file.gaodun.com/call-static/workbenchSdk.min.js`;
    try {
      var head_1 = document.getElementsByTagName('head')[0];
      head_1.appendChild(sIPmlScript);
      sIPmlScript.onload = function () {
        head_1.appendChild(indexScript);
        head_1.appendChild(workbenchSdk);
      };
    } catch (error) {}
    indexScript.onload = function () {
      loaded && resolve('loaded');
      loaded = true;
    };
    workbenchSdk.onload = function () {
      loaded && resolve('loaded');
      loaded = true;
    };
  });
};
// aliyun 2.o sdk
var loadAliPlusSdk = function () {
  var loaded = false;
  return new Promise(function (resolve, reject) {
    var sipDom = document.getElementById('aliPlusSipScript') || document.createElement('script');
    var indexDom = document.getElementById('aliPlusIndexScript') || document.createElement('script');
    var workbenchDom = document.getElementById('aliPlusWorkbenchScript') || document.createElement('script');
    if (sipDom) {
      sipDom && sipDom.remove();
      indexDom && indexDom.remove();
      workbenchDom && workbenchDom.remove();
    }
    var sIPmlScript = document.createElement('script');
    var indexScript = document.createElement('script');
    var workbenchSdk = document.createElement('script');
    sIPmlScript.type = 'text/javascript';
    indexScript.type = 'text/javascript';
    workbenchSdk.type = 'text/javascript';
    sIPmlScript.id = 'aliPlusSipScript';
    indexScript.id = 'aliPlusIndexScript';
    workbenchSdk.id = 'aliPlusWorkbenchScript';
    sIPmlScript.src = "https://g.alicdn.com/cloudcallcenter/SIPml/0.5.0/SIPml-api.js";
    indexScript.src = "https://g.alicdn.com/cloudcallcenter-voip/web-agentbar-sdk/1.10.0/index.js";
    workbenchSdk.src = "https://g.alicdn.com/cloudcallcenter/web-workbench-sdk/2.6.1/workbenchSdk.min.js";
    try {
      var head_2 = document.getElementsByTagName('head')[0];
      head_2.appendChild(sIPmlScript);
      sIPmlScript.onload = function () {
        head_2.appendChild(indexScript);
        head_2.appendChild(workbenchSdk);
      };
    } catch (error) {}
    indexScript.onload = function () {
      if (loaded) {
        resolve('loaded');
      } else {
        loaded = true;
      }
    };
    workbenchSdk.onload = function () {
      if (loaded) {
        resolve('loaded');
      } else {
        loaded = true;
      }
    };
  });
};
// 加载fbocc-js-sdk
var loadFboccJsV2 = function () {
  var loaded = false;
  return new Promise(function (resolve, reject) {
    var fboccDom = document.getElementById('fboccWebrtcJsV2');
    var fboccDkyDom = document.getElementById('fboccDkyJs');
    if (fboccDom && fboccDkyDom) {
      fboccDom.remove();
    }
    var fboccScript = document.createElement('script');
    fboccScript.type = 'text/javascript';
    fboccScript.id = 'fboccWebrtcJsV2';
    fboccScript.src = 'https://gd-file.gaodun.com/call-static/webrtc-fbocc-1.9.5.js';
    var fboccDkyScript = document.createElement('script');
    fboccDkyScript.type = 'text/javascript';
    fboccDkyScript.id = 'fboccDkyJs';
    fboccDkyScript.src = 'https://gd-file.gaodun.com/call-static/dky-webrtcSDK1.1.3-4.js';
    try {
      var head = document.getElementsByTagName('head')[0];
      head.appendChild(fboccScript);
      head.appendChild(fboccDkyScript);
    } catch (error) {}
    fboccScript.onload = function () {
      if (loaded) {
        resolve('loaded');
      } else {
        loaded = true;
      }
    };
    fboccDkyScript.onload = function () {
      if (loaded) {
        resolve('loaded');
      } else {
        loaded = true;
      }
    };
  });
};
//插入style 处理阿里云提示样式
var dealAliDesktopRemark = function () {
  if (!document.getElementById('aliyun_reamrk_style')) {
    var styleNode = document.createElement('style');
    styleNode.type = 'text/css';
    styleNode.id = 'aliyun_reamrk_style';
    styleNode.innerHTML = 'div[data-tag="gateway-wrapper"] {display: none;} .next-overlay-wrapper .next-overlay-backdrop{display: none;} .next-overlay-wrapper .next-dialog{display: none;} .next-overlay-wrapper div[role="alert"]{display: none;}';
    document.getElementsByTagName('head')[0].appendChild(styleNode);
  }
};
// 加载qidian-js-sdk
var loadQidianJs = function () {
  return new Promise(function (resolve, reject) {
    var fboccDom = document.getElementById('fboccWebrtcJs');
    if (fboccDom) {
      fboccDom.remove();
    }
    var fboccScript = document.createElement('script');
    fboccScript.type = 'text/javascript';
    fboccScript.id = 'qidianWebrtcJs';
    // fboccScript.src = 'https://bqq.gtimg.com/ccsdk/v2/qd-with-webrtc.js';
    fboccScript.src = 'https://gd-file.gaodun.com/call-static/qd-with-webrtc-v3.js';
    try {
      var head = document.getElementsByTagName('head')[0];
      head.appendChild(fboccScript);
    } catch (error) {}
    fboccScript.onload = function () {
      resolve('loaded');
    };
  });
};
var loadTianrunSdk = function () {
  return new Promise(function (resolve, reject) {
    var md5 = document.getElementById('tianrunMd5Script');
    var tianrunDom = document.getElementById('tianrunSdkScript');
    if (tianrunDom) {
      md5.remove();
      tianrunDom.remove();
    }
    var tianRunScript = document.createElement('script');
    var md5Script = document.createElement('script');
    tianRunScript.type = 'text/javascript';
    md5Script.type = 'text/javascript';
    //gaodun-crm.oss-cn-hangzhou.aliyuncs.com/md5.js
    md5Script.src = 'https://gd-file.gaodun.com/call-static/md5.js';
    //agent-gateway-1.cticloud.cn/js/agent/v10/cti-link.js
    tianRunScript.src = "//agent-gateway-1.cticloud.cn/js/agent/v10/cti-link.js";
    // tianRunScript.src = `https://gd-file.gaodun.com/call-static/cti-link.js`;
    md5Script.id = 'tianrunMd5Script';
    tianRunScript.id = 'tianrunSdkScript';
    var head = document.getElementsByTagName('head')[0];
    head.appendChild(md5Script);
    head.appendChild(tianRunScript);
    tianRunScript.onload = function () {
      resolve('loaded');
    };
  });
};
// fbocc 添加 全局事件 监听
// 注册事件
var registHandlFun = function (config) {
  window.updateState = function updateState(state) {
    console.log('updateState', state);
    if (state === 'UA_sip_registrationFailed') {
      // 注册失败 座席号不存在 or 密码错误 回调。。。
      config.onRegistrationFailed && config.onRegistrationFailed('fbocc', '注册失败， 座席号或密码错误');
    }
  };
  window.StopRing = function () {
    // eslint-disable-next-line prefer-const
    var dom = document.getElementById('WSringMusic');
    if (dom) {
      dom.src = '';
    }
  };
  window.StartRing = function () {
    // eslint-disable-next-line prefer-const
    var dom = document.getElementById('WSringMusic');
    if (dom) {
      dom.src = '';
    }
  };
};
// 获取企点 ticket appid kfext
var getQidianInfo = function (env, userId, isRefresh) {
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest();
    var url = "https://" + env + "apigateway.gaodun.com/solon/api/v1/qidian/user/ticket/" + userId + "?isRefresh=" + isRefresh;
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status >= 200 && xhr.status < 300 || xhr.status === 304) {
          var res = JSON.parse(xhr.response);
          resolve(res);
        }
      }
    };
    xhr.open('get', url, true);
    xhr.send();
  });
};
// jsonp实现天润话务鉴权
var tianrunAuthJsonp = function (url) {
  if (!url) {
    console.error('至少需要一个url参数!');
    return;
  }
  return new Promise(function (resolve, reject) {
    // @ts-ignore
    globalThis['jsonCallBack'] = function (result) {
      resolve(result);
    };
    var JSONP = document.createElement('script');
    JSONP.type = 'text/javascript';
    // @ts-ignore
    JSONP.src = url + "&callback=jsonCallBack";
    document.getElementsByTagName('head')[0].appendChild(JSONP);
    setTimeout(function () {
      document.getElementsByTagName('head')[0].removeChild(JSONP);
    }, 500);
  });
};

/*
 * @Author: zhuhd
 * @Date: 2021-04-20 10:35:26
 * @LastEditTime: 2021-12-20 13:35:56
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /gtools.gaodunwangxiao.com/src/plugins/src/browser-call/aliCall.ts
 */
var CreateAliCall = /** @class */function () {
  function CreateAliCall(props) {
    this.instance = null;
    this.offlineOnCalling = false;
    this.linkStatus = true;
    this.hideRemark = false;
    this.config = props;
    dealAliDesktopRemark();
    this.callInit();
  }
  /**
   * @description 切换状态【签入，签出，忙碌，小闲】
   * @param operate 1:签入， 2：签出，3：置忙， 4：置闲
   */
  CreateAliCall.prototype.switchStatus = function (operate) {
    if (this.offlineOnCalling) {
      this.config.onWarn('您的话务座席已在其他设备登录，请刷新页面');
      return;
    }
    if (!this.instance || !this.instance.getStatusCode) {
      this.config.onWarn('阿里云初始化失败，请填写正确的配置信息');
      return;
    }
    var code = this.instance.getStatusCode();
    if (!code) return;
    switch (operate) {
      // 签入
      case 1:
        if (code.code === 1) {
          this.instance.logIn();
        }
        break;
      // 签出
      case 2:
        try {
          this.instance.logOut();
        } catch (error) {
          console.log('签出 catch error:', error);
        }
        break;
      // 置忙
      case 3:
        this.instance.applyForBreak();
        break;
      // 置闲
      case 4:
        this.instance.ready();
        break;
    }
  };
  CreateAliCall.prototype.handleRemarkDisplay = function () {
    // if (this.hideRemark) {
    //     return;
    // }
    var remark = document.querySelector('.next-overlay-wrapper .next-feedback-medium');
    if (remark) {
      remark.style.display = 'none';
      this.hideRemark = true;
    }
  };
  CreateAliCall.prototype.callInit = function () {
    return __awaiter(this, void 0, void 0, function () {
      var res;
      var _this = this;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            console.log('callInit start load js');
            return [4 /*yield*/, loadAliSdk()];
          case 1:
            res = _a.sent();
            if (res !== 'loaded') return [2 /*return*/];
            // }
            console.log('callInit start load ends');
            this.instance = new window.WorkbenchSdk({
              dom: 'callContainer',
              afterCallRule: 5,
              instanceId: this.config.config.callExt,
              ajaxPath: '/ccc/authority',
              // ajaxPath: '/AliCC/CCapi',
              ajaxOtherParams: {
                userId: this.config.config.userId || this.config.userInfo.userId,
                agentId: this.config.userInfo.agentType || 1
              },
              ajaxOrigin: "https://" + (this.config.userInfo.environment || '') + "apigateway.gaodun.com/solon/api/v1/aliyun",
              // ajaxOrigin: `https://eds.gaodun.com/cloudcc`,
              ajaxMethod: 'post',
              isEnableGlobalNumbers: true,
              header: true,
              onInit: function (ret) {
                // setTimeout(() => {
                console.log('aliyun call init');
                var code = _this.instance.getStatusCode().code;
                if (code === -1) {
                  _this.instance.register();
                }
                // }, 1000);
              },
              onRegister: function (config) {},
              onErrorNotify: function (error) {
                console.log('ali-error', error, _this.config.onRegistrationFailed);
                // this.handleRemarkDisplay();
                _this.linkStatus = false;
                _this.config.onInstanceStatusChange(false, 'aliyun');
                if (error && error.errorCode === 8030) {
                  _this.offlineOnCalling = true;
                  _this.config.onWarn('您的话务座席已在其他设备登录，请在用户挂机后刷新页面即可，新开标签页请间隔5秒以上！', 4004);
                } else if (!_this.offlineOnCalling) {
                  if (error && (error.errorCode === 'KA_register' || error.errorCode === 8021)) {
                    _this.config.onClose && _this.config.onClose('browser', 'aliyun', error.errorMsgTip);
                    // 被踢下线 销毁实例
                  }
                  _this.config.onRegistrationFailed && _this.config.onRegistrationFailed('aliyun', error.errorMsgTip);
                }
              },
              onCallComing: function (connid, caller, calee, contactId) {
                var params = {
                  FromNo: caller,
                  ToNo: calee,
                  RecordId: contactId,
                  platform: 'aliyun',
                  phoneType: 1
                };
                // 来电提醒
                _this.config.onShowCommingCall({
                  FromNo: caller,
                  ToNo: calee,
                  RecordId: contactId,
                  platform: 'aliyun',
                  phoneType: 1
                });
                // 添加通话记录
                _this.config.addRecord(params, 'called', 'aliyun');
              },
              onCallDialing: function (connid, caller, calee, contactId) {
                var params = {
                  FromNo: caller,
                  ToNo: calee,
                  RecordId: contactId,
                  platform: 'aliyun',
                  phoneType: 2
                };
                // 添加通话记录
                _this.config.addRecord(params, 'call', 'aliyun');
              },
              onLogIn: function () {},
              onBreak: function () {},
              onReady: function () {},
              onHangUp: function () {
                _this.config.onHangup('aliyun');
              },
              onStatusChange: function (code, lastCode, context) {
                // 检测到通话状态，并改变导航右上角的话务状态为【...通话中】
                console.log('context', context);
                // this.handleRemarkDisplay();
                if (code !== -1 && !_this.linkStatus) {
                  _this.linkStatus = true;
                  _this.config.onInstanceStatusChange(true, 'aliyun');
                }
                /**
                 * 4 小休  置忙
                 * 6  振铃
                 * 8  拨号
                 * 9  呼入通话
                 * 10 呼出通话
                 */
                if ([1, 2, 3, 4].includes(code)) {
                  var statusMap = {
                    1: 'logOut',
                    2: 'login',
                    3: 'free',
                    4: 'busy'
                  };
                  _this.config.statusCodeChange(statusMap[code], 'aliyun');
                }
                if (code === 9 || code === 10) {
                  _this.config.onCall('aliyun');
                }
                if (code === 8) {
                  _this.config.onCallUp('aliyun');
                }
              },
              onCallRelease: function (connid, caller, privateData) {
                //  通话结束时触发
                var data = {
                  connid: connid,
                  caller: caller,
                  privateData: privateData
                };
                // 给后端发布电话释放的状态，需要请求接口
                _this.config.onReleaseCall && _this.config.onReleaseCall(data, 'aliyun');
              }
            });
            return [2 /*return*/];
        }
      });
    });
  };
  // 阿里拨打电话
  CreateAliCall.prototype.call = function (to) {
    if (!to) {
      this.config.onWarn('被叫号码不能为空号！');
      return;
    }
    if (!this.instance) {
      this.config.onWarn('阿里云账户信息缺失！');
      return;
    }
    var status = this.instance.getStatusCode();
    if (status) {
      if (status.code === 1) {
        this.instance.logIn();
      } else if (status.code === 12) {
        this.instance.callRetrieve();
        this.instance.hangUp();
      } else if (status.code === 8) {
        this.instance.hangUp();
      }
    }
    this.instance.call(to, 'auto');
    // store.dispatch({ type: SET_ALI_STATUS, payload: { aliStatus: 'up' } });
  };
  // 挂断电话
  CreateAliCall.prototype.hangup = function () {
    if (!this.instance || !this.instance.getStatusCode) return;
    var code = this.instance.getStatusCode().code;
    if (code === 6 || code === 8 || code === 9 || code === 10) {
      this.instance.hangUp();
    }
  };
  CreateAliCall.prototype.setConfig = function (config) {
    this.instance && (this.config = Object.assign({}, this.config, config));
  };
  // 接听电话
  CreateAliCall.prototype.answer = function () {
    this.instance.answer();
  };
  // 获取当前的话务状态
  CreateAliCall.prototype.getCallStatus = function () {
    if (this.instance) {
      var code = this.instance.getStatusCode().code;
      console.log('getCallStatus', code);
      var statusMap = {
        1: 'logOut',
        2: 'login',
        3: 'free',
        4: 'busy',
        6: 'ring',
        8: 'calling',
        9: 'talking',
        10: 'talking'
      };
      return statusMap[code];
    } else {
      return null;
    }
  };
  // 二次拨号
  CreateAliCall.prototype.sendDtmf = function (code) {
    console.log('sendDtmf', code);
    this.instance.sendDtmf(code);
  };
  CreateAliCall.prototype.destroy = function () {
    var _a, _b;
    try {
      console.log('destroy');
      this.config.onClose = undefined;
      this.config.onRegistrationFailed = undefined;
      this.instance && ((_a = this.instance) === null || _a === void 0 ? void 0 : _a.unloadWorkbench) && ((_b = this.instance) === null || _b === void 0 ? void 0 : _b.unloadWorkbench());
      this.instance = null;
    } catch (error) {
      console.log(error);
    }
  };
  return CreateAliCall;
}();

/*
 * @Author: zhuhd
 * @Date: 2022-10-10 10:05:52
 * @LastEditTime: 2022-12-09 10:05:52
 * @LastEditors: zhuhd
 * @Description: fbocc登录逻辑调整，由先登录分机 再登录坐席 改为 先登录坐席再登录分机
 * @FilePath: /gtools.gaodunwangxiao.com/src/plugins/src/browser-call/fobccCallV2.ts
 */
var CreateFobccCall = /** @class */function () {
  function CreateFobccCall(props) {
    var _this = this;
    this.instance = null;
    this.callStatus = 0;
    this.calluuid = '';
    this.status = true;
    // socket message callback
    this.handleCallback = function (type) {
      var params = JSON.parse(type.data); //返回的type为json类型，所以这里进行一下转换操作
      // linkedId  通话Id
      switch (params.eventType) {
        case 'Heartbeat':
          break;
        case 'AgentLogin':
          console.log('AgentLogin callback', params);
          if (params.code === '400') {
            // 有已登录分机正在通话  不再继续注册话务
            _this.config.onInstanceStatusChange && _this.config.onInstanceStatusChange('registerFailed', 'fbocc');
            _this.config.onRegistrationFailed && _this.config.onRegistrationFailed('fbocc', '存在正在通话的坐席，请通话结束后重试');
            _this.config.onInstanceStatusChange(false, 'fbocc');
            break;
          }
          // 现在回调在使用者这里处理，SDK又需要处理一部分状态，所以我(fbocc)做了这个函数，固定使用的
          // @ts-ignore
          agentState(params).then(function (res) {
            console.log('agentState callback', res);
            if ((res === null || res === void 0 ? void 0 : res.onlineflag) && (res === null || res === void 0 ? void 0 : res.onlineflag) === 'on') {
              _this.extenLogin();
            }
          });
          if (params.code === '200') {
            _this.config.statusCodeChange('free', 'fbocc');
          }
          break;
        case 'AgentState':
          // state 状态，**0**为在线，**1**为置忙
          _this.config.statusCodeChange(params.state === 0 ? 'free' : 'busy', 'fbocc');
          break;
        case 'MakeCall':
          // data  agentid code
          console.log('MakeCall', params);
          if (params.code !== '200') {
            // 处理外呼失败 下次坐席不能接收呼出指令问题
            window.DKY_CallState(0);
            _this.config.onWarn("\u547C\u53EB\u5931\u8D25\uFF1A" + params.message);
            _this.startFbocc();
          } else {
            _this.config.onCallUp('fbocc');
            var callParams = {
              FromNo: params.agentid,
              ToNo: params.callednum,
              RecordId: params.data.linkedid,
              platform: 'fbocc',
              phoneType: 2
            };
            _this.config.addRecord(callParams, 'call', 'fbocc');
          }
          // 不再使用retCode 判断风控
          // if (params.retCode && params.retCode !== '200' && params.message) {
          //     this.config.onWarn(`呼叫失败：${params.message}`);
          //     this.startFbocc();
          //     console.log('reset free');
          // }
          break;
        case 'DialStateEvent':
          if (params.callerRole == 'agent') {
            console.log('前端座席响铃');
            var callParams = {
              FromNo: params.destConnectedLineNum,
              ToNo: params.connectedLineNum,
              RecordId: params.linkedId,
              platform: 'fbocc',
              phoneType: 1
            };
            _this.config.addRecord(callParams, 'called', 'fbocc');
            _this.config.onShowCommingCall({
              FromNo: params.destConnectedLineNum,
              ToNo: params.connectedLineNum,
              RecordId: params.linkedId,
              platform: 'fbocc'
            });
          } else if (params.callerRole == 'phone') {
            console.log('前端客户响铃');
            // 拨出 用户响铃
            // 响铃由于运营商问题，偶先不触发该回调 改到makecall回调中更改状态 上报通话
            /* this.config.onCallUp('fbocc');
            const callParams = {
                FromNo: params.originate_tela,
                ToNo: params.originate_telb,
                RecordId: params.linkedId,
                platform: 'fbocc',
                phoneType: 2,
            };
            this.config.addRecord(callParams, 'call', 'fbocc'); */
          }
          break;
        case 'BridgeEnterEvent':
          console.log('BridgeEnterEvent', params);
          if (params.callerRole == 'agent') {
            _this.config.onCall('fbocc');
            console.log('前端座席接通');
          } else if (params.callerRole == 'phone') {
            console.log('前端客户接通');
          }
          break;
        case 'HangupEvent':
          console.log('HangupEvent', params);
          if (params.callerRole == 'agent') {
            _this.config.onHangup('fbocc');
            console.log('前端座席挂断');
          } else if (params.callerRole == 'phone') {
            console.log('前端客户挂断');
            window === null || window === void 0 ? void 0 : window.StopRing(); //现在事件监听执行交由使用者进行监听，呼入时需要监听一下客户端挂断事件，执行该方法停止座席响铃
          }
          break;
      }
    };
    // 在进行通信过程中发生错误的捕获函数
    this.onError = function (event) {
      _this.config.onInstanceStatusChange(false, 'fbocc');
      _this.config.onWarn('话务出错，请刷新页面重试');
    };
    // websocket连接关闭时获取到的回调函数
    this.onClose = function (event) {
      window.OnClose(event).then(function (res) {
        if (!_this.autoClose && _this.instance) {
          // 被踢下线
          _this.config.onClose && _this.config.onClose('broswer', 'fbocc', '您的账号已在别处登录');
        }
        _this.autoClose = false;
      }); //因为SDK内部有一些状态需要修改，而具体回调函数给与使用进行操作，所以需要固定位置执行一个固定函数
    };
    // 主动调用
    // 拨打  fbocc新版本 忙碌状态下可呼出 不可呼入
    this.call = function (phoneNo) {
      if (!phoneNo) return;
      console.log('call:', phoneNo);
      var call_object = {
        callednum: phoneNo,
        telX: '',
        userfield: ''
      };
      _this.config.onCallUp('fbocc'); // fbocc 响铃等回调触发较慢 呼叫立即设置为呼叫中
      window.DKY_MakeCALL(call_object).then(function (res) {
        console.log('外呼', res);
      });
    };
    // 挂断
    this.hangup = function () {
      window.DKY_HangUp();
    };
    this.answer = function () {
      window.DKY_Answer();
    };
    // 分机登录
    this.setOnline = function () {
      // 座席退出/分机退出 重新上线流程： 分机上线 、座席登录
      var _a = _this.config.config,
        token = _a.token,
        wsHost = _a.wsHost,
        ctiHost = _a.ctiHost,
        ctiWsPort = _a.ctiWsPort,
        extensionPassword = _a.extensionPassword,
        password = _a.password,
        wsPort = _a.wsPort,
        agentNo = _a.agentNo,
        callExt = _a.callExt,
        queue = _a.queue,
        companyId = _a.companyId,
        extensionNo = _a.extensionNo;
      /* window.DKY_exten_login(companyId, extensionNo, extensionPassword, ctiHost, ctiWsPort).then((res: any) => {
          // "EventName":"SIP_registered",
          // "Info":"分机登录成功"
          if (res.EventName === 'SIP_registered') {
              window.DKY_DOLogin(wsHost, wsPort, agentNo, extensionNo, companyId, token, queue, this.handleCallback, this.onClose, this.onError).then((loginRes: any) => {
                  if (loginRes?.onlineflag && loginRes?.onlineflag === 'on') {
                      this.config.statusCodeChange('login', 'fbocc');
                      this.config.onInstanceStatusChange(true, 'fbocc');
                      this.instance = true;
                      // this.switchStatus(4)
                  } else {
                      // error destroy
                      this.config.onInstanceStatusChange && this.config.onInstanceStatusChange('registerFailed', 'fbocc');
                      this.config.onRegistrationFailed && this.config.onRegistrationFailed('fbocc', loginRes.Info);
                      this.config.onInstanceStatusChange(false, 'fbocc');
                  }
              });
          } else {
              // 初始化失败。
              this.config.onInstanceStatusChange && this.config.onInstanceStatusChange('registerFailed', 'fbocc');
              this.config.onRegistrationFailed && this.config.onRegistrationFailed('fbocc', res.Info);
              this.config.onInstanceStatusChange(false, 'fbocc');
          }
      }); */
      // 坐席登录
      window.DKY_DOLogin(wsHost, wsPort, agentNo, extensionNo, companyId, token, queue, _this.handleCallback, _this.onClose, _this.onError).then(function (loginRes) {
        console.log('坐席登录', loginRes);
        if ((loginRes === null || loginRes === void 0 ? void 0 : loginRes.onlineflag) && (loginRes === null || loginRes === void 0 ? void 0 : loginRes.onlineflag) === 'on') ;else {
          console.log('坐席登录失败', loginRes);
          // error destroy
          _this.config.onInstanceStatusChange && _this.config.onInstanceStatusChange('registerFailed', 'fbocc');
          _this.config.onRegistrationFailed && _this.config.onRegistrationFailed('fbocc', loginRes.Info);
          _this.config.onInstanceStatusChange(false, 'fbocc');
        }
      });
    };
    // 分机登录
    this.extenLogin = function () {
      var _a = _this.config.config,
        token = _a.token,
        wsHost = _a.wsHost,
        ctiHost = _a.ctiHost,
        ctiWsPort = _a.ctiWsPort,
        extensionPassword = _a.extensionPassword,
        password = _a.password,
        wsPort = _a.wsPort,
        agentNo = _a.agentNo,
        callExt = _a.callExt,
        queue = _a.queue,
        companyId = _a.companyId,
        extensionNo = _a.extensionNo;
      window.DKY_exten_login(companyId, extensionNo, extensionPassword, ctiHost, ctiWsPort).then(function (res) {
        // "EventName":"SIP_registered",
        // "Info":"分机登录成功"
        console.log('分机登录', res);
        if (res.EventName === 'SIP_registered') {
          // this.config.statusCodeChange('login', 'fbocc');
          _this.config.onInstanceStatusChange(true, 'fbocc');
          _this.instance = true;
        } else {
          console.log('分机登录失败', res);
          // 初始化失败。
          _this.config.onInstanceStatusChange && _this.config.onInstanceStatusChange('registerFailed', 'fbocc');
          _this.config.onRegistrationFailed && _this.config.onRegistrationFailed('fbocc', res.Info);
          _this.config.onInstanceStatusChange(false, 'fbocc');
        }
      });
    };
    // 登录
    this.logOnFbocc = function () {
      if (!_this.agentInfo) {
        _this.config.onWarn('登录时没有坐席号');
        return;
      }
      var agent = _this.agentInfo.agent;
      _this.setOnline();
    };
    // 登出
    this.logOffFbocc = function () {
      if (!_this.agentInfo) {
        _this.config.onWarn('登录时没有坐席号');
        return;
      }
      window.DKY_unDoLogin().then(function (res) {
        if (res.onlineflag === 'off') {
          _this.autoClose = true;
          _this.config.statusCodeChange('logOut', 'fbocc');
        }
      });
    };
    // 置忙
    this.pauseFbocc = function () {
      if (!_this.agentInfo) {
        _this.config.onWarn('设置忙碌时没有坐席号');
        return;
      }
      window.DKY_Pauses(1, 'restting').then(function (res) {
        //如果置忙成功，then函数不会被触发
      });
    };
    // 置闲
    this.startFbocc = function () {
      if (!_this.agentInfo) {
        _this.config.onWarn('设置小闲时没有坐席号');
        return;
      }
      window.DKY_Pauses(0).then(function (res) {
        //如果置忙成功，then函数不会被触发
      });
    };
    // 导航右上角话务状态手动切换
    this.switchStatus = function (operate) {
      if (!operate) return;
      switch (operate) {
        case 1:
          // 签入
          _this.logOnFbocc();
          break;
        case 2:
          // 签出
          _this.logOffFbocc();
          break;
        case 3:
          // 置忙
          _this.pauseFbocc();
          break;
        case 4:
          // 置闲
          _this.startFbocc();
          break;
      }
    };
    this.resetFboccToken = function (token) {
      // 不需要重置 token token过期逻辑由服务商处理
    };
    this.destroy = function () {
      try {
        _this.logOffFbocc();
        _this.instance = null;
        _this.config.onClose = undefined;
        _this.config.onRegistrationFailed = undefined;
      } catch (error) {}
    };
    this.autoClose = false;
    this.config = props;
    this.agentInfo = {
      agent: props.config.callExt,
      password: props.config.password
    };
    this.fboccConfig = props === null || props === void 0 ? void 0 : props.fboccInfo.config;
    registHandlFun(this.config);
    this.callInit();
  }
  CreateFobccCall.prototype.callInit = function () {
    return __awaiter(this, void 0, void 0, function () {
      var loadStatus;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, loadFboccJsV2()];
          case 1:
            loadStatus = _a.sent();
            if (loadStatus !== 'loaded') return [2 /*return*/];
            this.setOnline();
            return [2 /*return*/];
        }
      });
    });
  };
  CreateFobccCall.prototype.setConfig = function (config) {
    this.instance && (this.config = Object.assign({}, this.config, config));
    // registHandlFun
  };
  // 二次拨号
  CreateFobccCall.prototype.sendDtmf = function (code) {
    window.DKY_secondary_call(code);
  };
  return CreateFobccCall;
}();

// let enableInitJs = true;
var CreateTengxunCall = /** @class */function () {
  function CreateTengxunCall(props) {
    var _this = this;
    this.instance = null;
    this.callid = '';
    this.appId = '';
    this.ticket = '';
    this.isRingOrTalking = false;
    this.otherOriginClient = false;
    this.isBusy = false;
    this.environment = '';
    this.kfext = '';
    this.firstRefreshTime = 0; // 短时间内第一次刷新 ticket 时间戳
    this.refreshTicketCount = 0;
    // 状态推送处理
    this.handleStatusChange = function (res) {
      console.log('handleStatusChange', res);
      if (res.CallDirection && res.CallDirection === 2) {
        // 外呼
        _this.handleCallOutState(res);
      }
      if (res.CallDirection && res.CallDirection === 1) {
        //  呼入
        _this.handleCallinState(res);
      }
    };
    this.config = props;
    this.userId = props.config.userId || props.userInfo.userId;
    this.environment = props.userInfo.environment;
    this.otherOriginClient = props.userInfo.otherOriginClient;
    this.ticket = props.config.ticket;
    this.kfext = props.config.kfext;
    this.appId = props.config.appId;
    this.callInit();
  }
  CreateTengxunCall.prototype.initQidianInfo = function (isRefresh) {
    if (isRefresh === void 0) {
      isRefresh = true;
    }
    return __awaiter(this, void 0, void 0, function () {
      var enableRequest, interval, times, res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            enableRequest = true;
            // if (isRefresh) {
            if (!this.firstRefreshTime) {
              this.firstRefreshTime = Date.now();
            } else {
              interval = Date.now() - this.firstRefreshTime;
              times = interval < 1000 || interval < 3000 || interval < 10000 || interval < 30000;
              if (this.refreshTicketCount > 3 && times) {
                // 短时间内 多次刷新该接口  禁止后续刷新 ticket
                enableRequest = false;
                this.config.onWarn('短时间内多次请求ticket，请检查话务配置或联系技术人员');
              }
            }
            if (!enableRequest) return [3 /*break*/, 2];
            return [4 /*yield*/, getQidianInfo(this.environment, this.userId, isRefresh)];
          case 1:
            res = _a.sent();
            if (res.status === 0 && res.result) {
              // 刷新 ticket
              this.ticket = res.result;
              this.instance.goon({
                ticket: res.result
              });
              this.refreshTicketCount += 1;
            } else {
              this.config.onWarn(res.status === 0 ? '请检查企点话务配置' : res.info);
            }
            _a.label = 2;
          case 2:
            return [2 /*return*/];
        }
      });
    });
  };
  /**
   * @description 切换状态【签入，签出，忙碌，小闲】
   * @param operate 1:签入， 2：签出，3：置忙， 4：置闲
   */
  CreateTengxunCall.prototype.switchStatus = function (operate) {
    return __awaiter(this, void 0, void 0, function () {
      var isLogin;
      var _this = this;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, this.getIsLogin()];
          case 1:
            isLogin = _a.sent();
            if (!this.instance || !isLogin) {
              console.log(!this.instance ? '企点话务初始化失败' : '企点话务未登陆');
              this.config.onWarn(!this.instance ? '企点话务初始化失败' : '企点话务未登陆');
              return [2 /*return*/];
            }
            switch (operate) {
              // 签入
              case 1:
                this.instance.agentOnWork({
                  kfext: this.kfext,
                  type: 5,
                  success: function (res) {
                    // 结果 0 成功 非0标识执行失败
                    res.code === 0 && _this.config.statusCodeChange('login', 'tengxun');
                  }
                });
                break;
              // 签出
              case 2:
                this.instance.agentOffWork({
                  kfext: this.kfext,
                  type: 5,
                  success: function (res) {
                    // 结果 0 成功 非0标识执行失败
                    // res.code === 0 && this.config.statusCodeChange('logOut', 'tengxun');
                  }
                });
                break;
              // 置忙
              case 3:
                this.instance.agentSetWorkStatus({
                  kfext: this.kfext,
                  type: 5,
                  code: 1,
                  status: 0,
                  success: function (res) {
                    _this.config.statusCodeChange('busy', 'tengxun');
                    _this.isBusy = true;
                  },
                  fail: function (err) {
                    console.log('置忙失败', err);
                  }
                });
                break;
              // 置闲
              case 4:
                this.instance.agentSetWorkStatus({
                  kfext: this.kfext,
                  type: 5,
                  code: 1,
                  status: 1,
                  success: function (res) {
                    console.log('agentSetWorkStatus 置闲');
                    _this.config.statusCodeChange('free', 'tengxun');
                    _this.isBusy = false;
                  },
                  fail: function (err) {
                    console.log('置闲失败', err);
                  }
                });
                break;
            }
            return [2 /*return*/];
        }
      });
    });
  };
  CreateTengxunCall.prototype.getIsLogin = function () {
    var _this = this;
    return new Promise(function (resolve, reject) {
      _this.instance.isAgentLogin({
        kfext: _this.kfext,
        success: function (res) {
          resolve(true);
        },
        fail: function (err) {
          reject(false);
        }
      });
    });
  };
  // 外呼推送状态处理
  CreateTengxunCall.prototype.handleCallOutState = function (res) {
    switch (res.CallStatus) {
      case 2:
        // c端 振铃
        break;
      case 3:
        if (res.CallClientType === 0) {
          // 连接企点系统 成功  系统拨号
          this.config.onCallUp('tengxun');
          this.isRingOrTalking = true;
          // 添加通话记录
          var params = {
            FromNo: res.Caller,
            ToNo: res.Callee,
            RecordId: res.CallId,
            platform: 'tengxun',
            CountryCode: res.CountryCode,
            phoneType: 2
          };
          this.config.addRecord(params, 'call', 'tengxun');
        } else {
          // c端 接听通话
          this.config.onCall('tengxun');
        }
        break;
      case 4:
        // hangup
        // this.config.onHangup('tengxun');
        // this.isRingOrTalking = false;
        break;
      case 13:
        // 通话结束
        // this.config.onCallRelease()
        this.isRingOrTalking = false;
        break;
    }
  };
  // 呼入推送状态处理   呼入通过
  CreateTengxunCall.prototype.handleCallinState = function (res) {
    // 呼入时  置忙状态推送 可能在 响铃状态推送前 也可能在其后。。。
    switch (res.CallStatus) {
      case 2:
        var params = {
          FromNo: res.Caller,
          ToNo: res.Callee,
          RecordId: res.CallId,
          platform: 'tengxun',
          CountryCode: res.CountryCode,
          phoneType: 1
        };
        this.callid = res.CallId;
        this.config.onShowCommingCall(params);
        this.config.addRecord(params, 'called', 'tengxun');
        this.isRingOrTalking = true;
        break;
      case 3:
        // 坐席端 接听通话
        this.config.onCall('tengxun');
        break;
      case 4:
      case 19:
        // 19主动挂断 或 用户拒接
        // hangup
        // this.config.onHangup('tengxun');
        // this.isRingOrTalking = false;
        break;
      case 13:
        // 通话结束
        this.isRingOrTalking = false;
        break;
    }
  };
  CreateTengxunCall.prototype.callInit = function () {
    return __awaiter(this, void 0, void 0, function () {
      var res;
      var _this = this;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.config.onInstanceStatusChange && this.config.onInstanceStatusChange('loading', 'tengxun');
            return [4 /*yield*/, loadQidianJs()];
          case 1:
            res = _a.sent();
            if (res !== 'loaded') return [2 /*return*/];
            // enableInitJs = false;
            // }
            // 调用该函数起别名可避免重名所造成的冲突。
            // @ts-ignore
            window.qdCall = this.instance = window.qd.noConflict();
            this.instance.config({
              mode: 'webrtc',
              version: 1,
              // el: '#qd_agentbar', // 要渲染出agentbar的dom节点
              appId: this.appId,
              kfext: this.kfext,
              ticket: this.ticket,
              debug: false,
              success: function (res) {
                // 鉴权成功 后执行 置闲  版本修改后 需要加延时
                setTimeout(function () {
                  _this.switchStatus(4);
                  _this.config.onInstanceStatusChange && _this.config.onInstanceStatusChange('registered', 'tengxun');
                }, 500);
              },
              fail: function (res) {
                console.log('register fail', res);
                var msg = res.code === 3 ? '话务登录已过期, 请刷新页面重试' : '话务注册失败，请重新登陆或联系CRM技术检查话务配置！';
                // 鉴权失败回调
                _this.config.onInstanceStatusChange && _this.config.onInstanceStatusChange('registerFailed', 'tengxun');
                _this.config.onRegistrationFailed && _this.config.onRegistrationFailed('tengxun', msg);
              }
            });
            // this.instance.connect(() => {
            // 	// 连接建立后的回调
            // 	console.log('connect success');
            // });
            this.instance.debug(false);
            this.instance.on('configsSetted', function (res) {
              console.log('configsSetted', res);
            });
            // 自动接听状态推送
            this.instance.on('autoAnswerChange', function (e, res) {
              console.log('自动接听状态推送', res);
            });
            // 登出推送
            this.instance.on('logout', function (e, res) {
              console.log('登出推送', res);
              _this.config.statusCodeChange('logOut', 'tengxun');
            });
            // 在线、离线状态推送
            this.instance.on('onlineStatusChange', function (e, res) {
              console.log('在线、离线状态推送 ', res);
            });
            // 用于推送坐席电话状态（空闲、忙碌）
            this.instance.on('answerTypeChange', function (e, res) {
              // 2 空闲、 3 忙碌
              console.log('用于推送坐席电话状态（空闲、忙碌）', res);
              if (!_this.isRingOrTalking) {
                _this.config.statusCodeChange(res.AnswerType === 2 ? 'free' : 'busy', 'tengxun');
                _this.isBusy = res.AnswerType === 3;
              }
            });
            this.instance.on('ticketExpired', function (e, res) {
              var _a;
              console.log('ticketExpired ticket 过期');
              //这里需要请求业务接口更新ticket；
              //获取有效ticket后调用qd.goon({ticket: 'sdfs5252sdf5sdf'});
              //可以继续上次中断的动作
              // resetToken
              _this.otherOriginClient ? (_a = _this.config) === null || _a === void 0 ? void 0 : _a.onTokenOutDate('tengxun') : _this.initQidianInfo(true);
            });
            this.instance.on('disconnect', function (e, res) {
              // 事件在连接断开时触发，如被踢下线或其他原因socket被断开  res: 'socketbreak' | others
              res !== 'socketbreak' && _this.config.onInstanceStatusChange && _this.config.onInstanceStatusChange('disconnected', 'tengxun');
              console.log('事件在连接断开时触发，如被踢下线或其他原因socket被断开', res);
            });
            this.instance.on('socketbreak', function () {
              var _a, _b, _c;
              // 被踢下线 如正在通话 挂断电话
              var status = (_a = _this.instance) === null || _a === void 0 ? void 0 : _a.getState('status');
              if (status !== 'normal' && status !== 'over') {
                (_b = _this.instance) === null || _b === void 0 ? void 0 : _b.hangup({
                  callid: (_c = _this.instance) === null || _c === void 0 ? void 0 : _c.getState('callid')
                });
              }
              _this.config.onInstanceStatusChange && _this.config.onInstanceStatusChange('outline', 'tengxun');
              _this.config.onClose && _this.config.onClose('browser', 'tengxun', '话务账号被踢下线，请刷新当前页面重试！');
            });
            this.instance.error(function (res) {
              console.log('tengxun-error', res);
              _this.config.onInstanceStatusChange('', 'tengxun');
              _this.config.onRegistrationFailed && _this.config.onRegistrationFailed('tengxun', res.msg);
            });
            this.instance.on('statusChange', function (e, res) {
              _this.handleStatusChange(res);
            });
            this.instance.on('stateChange', function (e, state) {
              // 结束通话统一在此处理
              if (state === 'over') {
                _this.config.onHangup('tengxun');
                _this.isRingOrTalking = false;
              }
            });
            return [2 /*return*/];
        }
      });
    });
  };
  // 非网校对接刷新ticket
  CreateTengxunCall.prototype.resetToken = function (token) {
    this.instance.goon({
      ticket: token
    });
  };
  // 打电话
  CreateTengxunCall.prototype.call = function (to) {
    return __awaiter(this, void 0, void 0, function () {
      var _this = this;
      return __generator(this, function (_a) {
        // const isLogin = await this.getIsLogin();
        // this.instance.isValidNumber({
        // 	phone_number: to,
        // 	success: async (res: any) => {
        // 		if(res.code === 0) {
        this.instance.agentMakeCall({
          phone_number: to,
          num_display_type: 1,
          client_account_type: 5,
          user_data: '',
          user_display_num: '',
          success: function (res) {
            // console.log('tonghua', res);
            _this.isRingOrTalking = true;
            _this.callid = res.callid;
          },
          fail: function (res) {
            // this.config.onWarn(`拨号失败：${res.msg}`)
            console.log(res);
            _this.config.onCallFail("\u62E8\u53F7\u5931\u8D25\uFF1A" + res.msg, 'tengxun');
            // console.log('tonghua fail', res);
          }
        });
        return [2 /*return*/];
      });
    });
  };
  // 挂断电话
  CreateTengxunCall.prototype.hangup = function () {
    var _this = this;
    if (this.callid) {
      this.instance.hangup({
        callid: this.callid,
        success: function (res) {
          if (res.code === 0) {
            _this.callid = '';
            _this.isRingOrTalking = false;
          }
        },
        fail: function (res) {
          console.log('挂断失败。。。', res);
        }
      });
    }
  };
  // 获取当前的话务状态
  /* getCallStatus() {
      // this.instance.isAgentLogin({
      //     kfext: 2852400565,
      //     success: function(res) {},
      //     fail: function(err){}
      // })
      //  是否在通话中 通话状态
     this.instance.getCallStatus({
        success: (res: IQdgetCallStatus) => {
            if(res.code !== 0) return
            if(res.agent_status === 0) {
                // 不在通话中
            } else if(res.agent_status === 1){
              // 正在通话  2 振铃，3 通话中
              if(res.call_status === 2){
                  // return 6
              }
              if(res.call_status === 3) {
                  // return 10
              }
            }
        }
     })
  } */
  // 接听电话
  CreateTengxunCall.prototype.answer = function () {
    // 接听电话未返回 called     挂断需要
    this.instance.answer({
      success: function (res) {},
      fail: function (res) {}
    });
  };
  // 二次拨号
  CreateTengxunCall.prototype.sendDtmf = function (code) {
    this.instance.dialClick({
      kfext: this.kfext,
      key: code,
      success: function (res) {
        console.log('success', res);
      },
      fail: function (err) {
        console.log('fail', err);
      }
    });
  };
  CreateTengxunCall.prototype.setConfig = function (config) {
    this.instance && (this.config = Object.assign({}, this.config, config));
  };
  CreateTengxunCall.prototype.destroy = function () {
    // 暂不支持 销毁
    try {
      this.instance = null;
    } catch (error) {}
    this.config.onClose = undefined;
    this.config.onRegistrationFailed = undefined;
  };
  return CreateTengxunCall;
}();

/*
 * @Author: zhuhd
 * @Date: 2022-01-21 16712:26
 * @LastEditTime: 2022-01-21 16712:26
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /gtools.gaodunwangxiao.com/src/plugins/src/browser-call/tianrunCall.ts
 */
var CreateTianrunCall = /** @class */function () {
  function CreateTianrunCall(props) {
    this.instance = null;
    this.callExt = ''; // 座席号
    this.bindPhone = ''; // 天润座席绑定号码
    this.config = props;
    this.callExt = props.config.callExt;
    this.bindPhone = props.config.bindPhone;
    this.callInit();
  }
  /**
   * @description 坐席登录
   * @param params
   */
  CreateTianrunCall.prototype.loginTianrun = function (params) {
    var _this = this;
    this.instance.Agent.login(params, function (result) {
      if (Number(result.code) !== 0) {
        _this.config.onInstanceStatusChange && _this.config.onInstanceStatusChange('registerFailed', 'tianrun');
        _this.config.onRegistrationFailed && _this.config.onRegistrationFailed('tianrun', result.msg ? "\u8BDD\u52A1\u6CE8\u518C\u5931\u8D25\uFF0C" + result.msg : '话务注册失败，请重新登陆或联系CRM技术检查话务配置！');
      }
      // this.config.onInstanceStatusChange && this.config.onInstanceStatusChange('registered', 'tianrun');
    });
  };
  // 登录
  CreateTianrunCall.prototype.doLogin = function () {
    return __awaiter(this, void 0, void 0, function () {
      var url, callcentId, timestamp, authToken, cno, sign, res, data, msg, params, e_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = '//api-1.cticloud.cn/interface/v10/agentLogin/authenticateJsonp';
            callcentId = '7100019';
            timestamp = Math.round(new Date().getTime() / 1000);
            authToken = 'e440f6d7be1235d812a788f3d4f19db4';
            cno = this.callExt;
            sign = window.calcMD5(callcentId + timestamp + authToken);
            url += "?validateType=2&enterpriseId=" + callcentId + "&cno=" + cno + "&timestamp=" + timestamp + "&sign=" + sign;
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3,, 4]);
            return [4 /*yield*/, tianrunAuthJsonp(url)];
          case 2:
            res = _a.sent();
            data = JSON.parse(res);
            if (data.result === -1) {
              msg = data.description === 'agent not exist' ? '话务注册失败，座席不存在' : '话务注册失败，请重新登陆或联系CRM技术检查话务配置！';
              this.config.onInstanceStatusChange && this.config.onInstanceStatusChange('registerFailed', 'tianrun');
              this.config.onRegistrationFailed && this.config.onRegistrationFailed('tianrun', msg);
              return [2 /*return*/];
            }
            params = {
              sessionKey: data.sessionKey,
              enterpriseId: data.enterpriseId,
              cno: data.cno,
              bindTel: this.bindPhone,
              bindType: 3,
              loginStatus: 1,
              webSocketUrl: data.agentGateWayUrl,
              qids: data.qids
            };
            this.loginTianrun(params);
            return [3 /*break*/, 4];
          case 3:
            e_1 = _a.sent();
            console.log('接口请求错误');
            return [3 /*break*/, 4];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  };
  // 退出
  CreateTianrunCall.prototype.dologout = function () {
    try {
      var logoutParams = {
        logoutMode: 1,
        removeBinding: 0
      };
      this.instance.Agent.logout(logoutParams);
    } catch (error) {
      console.log('签出 catch error:', error);
    }
  };
  // 响铃处理
  CreateTianrunCall.prototype.handleRing = function (params) {
    this.config.onCallUp();
    var ringActions = ['ringingIb', 'ringingAgentOb'];
    var exisistAction = ringActions.find(function (action) {
      return action === params.stateAction;
    });
    if (exisistAction) {
      if (params.stateAction === 'ringingAgentOb') {
        // 拨号
        var target = {
          FromNo: params.cno,
          ToNo: params.customerNumber,
          RecordId: params.uniqueId,
          platform: 'tianrun',
          phoneType: 2
        };
        this.config.addRecord(target, 'call', 'tianrun');
      } else {
        // 来电
        var target = {
          FromNo: params.customerNumber,
          ToNo: params.cno,
          RecordId: params.uniqueId,
          platform: 'tianrun',
          phoneType: 1
        };
        this.config.onShowCommingCall(target);
        this.config.addRecord(target, 'called', 'tianrun');
      }
    }
  };
  // 处理通话中状态  接听
  CreateTianrunCall.prototype.handleTalking = function (params) {
    var talkActions = ['busyOb', 'busyIb'];
    var exisistAction = talkActions.find(function (action) {
      return action === params.stateAction;
    });
    if (exisistAction) {
      this.config.onCall('tianrun');
    }
  };
  /**
   * @description 切换状态【签入，签出，忙碌，小闲】
   * @param operate 1:签入， 2：签出，3：置忙， 4：置闲
   */
  CreateTianrunCall.prototype.switchStatus = function (operate) {
    switch (operate) {
      // 签入
      case 1:
        this.doLogin();
        break;
      // 签出
      case 2:
        this.dologout();
        break;
      // 置忙
      case 3:
        var params = {
          pauseType: 1,
          pauseDescription: '小休'
        };
        this.instance.Agent.pause(params);
        break;
      // 置闲
      case 4:
        this.instance.Agent.unpause();
        break;
    }
  };
  CreateTianrunCall.prototype.handleState = function (event) {
    switch (event.state) {
      case '离线':
        this.config.statusCodeChange('logOut', 'tianrun');
        break;
      case '失效':
        //软电话状态, 退出
        this.dologout();
        console.log('失效', event);
        break;
      case '空闲':
        this.config.statusCodeChange('free', 'tianrun');
        break;
      case '置忙':
        this.config.statusCodeChange('busy', 'tianrun');
        break;
      case '呼叫中':
        break;
      case '响铃':
        this.handleRing(event);
        break;
      case '通话':
        this.handleTalking(event);
        break;
      case '整理':
        this.config.onHangup('tianrun');
        break;
    }
  };
  // 弹屏
  CreateTianrunCall.prototype.handleRinging = function () {
    // console.log('弹屏');
  };
  // 天润被踢下线
  CreateTianrunCall.prototype.handleKickout = function () {
    this.config.onClose && this.config.onClose('browser', 'tianrun', '话务账号被踢下线，请刷新当前页面重试！');
  };
  CreateTianrunCall.prototype.callInit = function () {
    return __awaiter(this, void 0, void 0, function () {
      var res;
      var _this = this;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, loadTianrunSdk()];
          case 1:
            res = _a.sent();
            if (res !== 'loaded') return [2 /*return*/];
            // init
            window.CTILink.setup({
              webrtc: true,
              debug: false
            }, function () {
              //CTILink加载完成
              _this.instance = window.CTILink;
              //注册事件处理方法
              /** 状态事件 */
              _this.instance.event('status', function (event) {
                return _this.handleState(event);
              }); //当前座席状态
              _this.instance.event('previewOutcallRinging', function (event) {
                return _this.handleState(event);
              }); //外呼座席响铃
              _this.instance.event('previewOutcallBridge', function (event) {
                return _this.handleState(event);
              }); //外呼接通
              _this.instance.event('consultStart', function (event) {
                return _this.handleState(event);
              }); //咨询开始
              _this.instance.event('consultLink', function (event) {
                return _this.handleState(event);
              }); //咨询接听
              _this.instance.event('consultError', function (event) {
                return _this.handleState(event);
              }); //咨询失败
              _this.instance.event('unconsult', function (event) {
                return _this.handleState(event);
              }); //咨询挂断/接回/取消
              _this.instance.event('consultThreeway', function (event) {
                return _this.handleState(event);
              }); //咨询三方
              _this.instance.event('consultThreewayUnlink', function (event) {
                return _this.handleState(event);
              }); //咨询三方挂断
              _this.instance.event('consultTransfer', function (event) {
                return _this.handleState(event);
              }); //咨询转移
              /** 其他事件 */
              _this.instance.event('ringing', function () {
                return _this.handleRinging();
              }); //弹屏
              _this.instance.event('kickout', function () {
                return _this.handleKickout();
              }); //被踢下线
              _this.instance.event('breakLine', function (event) {
                if (event.code == -1) {
                  if (event.attempts >= 20) {
                    _this.config.onWarn('自动断线重连失败，请重新登录');
                  }
                }
              });
              // 软电话断线，座席需要重新登录
              // CTILink.event("sipDisconnected", function() {});
              //自动登录
              _this.doLogin();
            });
            return [2 /*return*/];
        }
      });
    });
  };
  // 拨打电话
  CreateTianrunCall.prototype.call = function (to) {
    var _this = this;
    if (!to) {
      this.config.onWarn('被叫号码不能为空号！');
      return;
    }
    // if (!this.instance) {
    //     this.config.onWarn('阿里云账户信息缺失！');
    //     return;
    // }
    var params = {
      tel: to
    };
    this.instance.Agent.previewOutcall(params, function (res) {
      if (res.code === '-1') {
        var msg = res.msg === '无可用中继' ? '号码被风控限制' : '请检测号码格式';
        _this.config.onWarn("\u547C\u53EB\u5931\u8D25\uFF0C" + msg);
      }
    });
  };
  // 挂断电话
  CreateTianrunCall.prototype.hangup = function () {
    if (this.instance.Session.isSessionAlive()) {
      this.instance.Session.unlink();
    }
  };
  // 拒接
  CreateTianrunCall.prototype.refuse = function (description) {
    if (description === void 0) {
      description = '忙碌';
    }
    var params = {
      description: description
    };
    this.instance.Session.refuse(params);
  };
  CreateTianrunCall.prototype.setConfig = function (config) {
    this.instance && (this.config = Object.assign({}, this.config, config));
  };
  // 接听电话
  CreateTianrunCall.prototype.answer = function () {
    this.instance.SipSession.sipLink();
  };
  // 二次拨号
  CreateTianrunCall.prototype.sendDtmf = function (code) {
    var params = {
      digits: code,
      direction: 2
    };
    this.instance.Session.dtmf(params);
  };
  CreateTianrunCall.prototype.destroy = function () {
    try {
      this.config.onClose = undefined;
      this.config.onRegistrationFailed = undefined;
      this.instance = null;
    } catch (error) {
      console.log(error);
    }
  };
  return CreateTianrunCall;
}();

/*
 * @Author: zhuhd
 * @Date: 2022-02-25 10:35:26
 * @LastEditTime: 2022-02-25 10:35:26
 * @LastEditors: zhuhd
 * @Description: In User Settings Edit
 * @FilePath: /gtools.gaodunwangxiao.com/src/plugins/src/browser-call/aliPlusCall.ts
 */
var errorMaps = {
  5001: '外呼失败',
  5002: '您尚未被加入到技能组中，暂时无法使用，请联系呼叫中心管理员添加',
  5003: '技能组信息异常',
  5004: '请检查坐席是否在通话中，并且设置了语音满意度流程',
  5005: '当前WebScoket连接缓慢，请等待或刷新后重新上线',
  6001: '没有通话Channel信息',
  6002: '没有通话ChannelID',
  7001: '已有设备注册，软电话未初始化',
  7002: '已有设备注册，软电话初始化异常, 请刷新页面',
  7003: '无法获取接入点信息',
  7004: '接入点测速失败',
  7005: '请使用http协议',
  7006: '浏览器不满足要求',
  7007: '坐席账号被踢下线，请刷新当前页面重试！',
  7008: 'SIP话机不在线',
  9001: '当前状态不能执行此操作',
  9002: '参数异常',
  9003: '执行失败',
  9004: '软电话已初始化好',
  9005: '请先调用PrepareSignIn方法',
  9006: '下线失败',
  9007: '网络连接失败',
  9008: '缺少登录信息',
  9009: '主叫为空',
  9010: '无可用主叫',
  9011: '主叫已用完',
  9012: '被叫为空',
  8001: '请检查声卡权限',
  8002: '请检查声卡权限',
  8003: '已在通话中',
  8004: '无语音流'
};
var PLATFORM = 'aliyunPlus';
var CreateAliPlusCall = /** @class */function () {
  function CreateAliPlusCall(props) {
    this.instance = null;
    this.linkStatus = true;
    this.config = props;
    dealAliDesktopRemark();
    this.callInit();
  }
  /**
   * @description 切换状态【签入，签出，忙碌，小闲】
   * @param operate 1:签入， 2：签出，3：置忙， 4：置闲
   */
  CreateAliPlusCall.prototype.switchStatus = function (operate) {
    if (!this.instance || !this.instance.getStatusCode) {
      this.config.onWarn('阿里云初始化失败，请填写正确的配置信息');
      return;
    }
    var code = this.instance.getStatusCode();
    if (!code) return;
    switch (operate) {
      // 签入
      case 1:
        if (code.code === 1) {
          this.instance.logIn();
        }
        break;
      // 签出
      case 2:
        try {
          this.instance.logOut();
        } catch (error) {
          console.log('签出 catch error:', error);
        }
        break;
      // 置忙
      case 3:
        this.instance.applyForBreak();
        break;
      // 置闲
      case 4:
        this.instance.ready();
        break;
    }
  };
  CreateAliPlusCall.prototype.callInit = function () {
    return __awaiter(this, void 0, void 0, function () {
      var res, ajaxOrigin, ajaxPath;
      var _this = this;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, loadAliPlusSdk()];
          case 1:
            res = _a.sent();
            if (res !== 'loaded') return [2 /*return*/];
            ajaxOrigin = "https://" + (this.config.userInfo.environment || '') + "apigateway.gaodun.com/usopp/api/v1/aliyun";
            ajaxPath = '/ccc/api';
            if (this.config.userInfo.otherOriginClient) {
              ajaxOrigin = this.config.config.ajaxOrigin;
              ajaxPath = this.config.config.ajaxPath;
            }
            this.instance = new window.WorkbenchSdk({
              dom: 'callContainer',
              afterCallRule: 5,
              regionId: 'cn-shanghai',
              instanceId: this.config.config.callExt,
              ajaxPath: ajaxPath,
              ajaxOtherParams: {
                userId: this.config.config.userId || this.config.userInfo.userId,
                agentType: this.config.userInfo.agentType || 1
              },
              ajaxOrigin: ajaxOrigin,
              ajaxMethod: 'post',
              isEnableGlobalNumbers: true,
              header: true,
              // ...sdkFetchConfig,
              onInit: function (ret) {
                console.log('aliyunPlus call init');
                var code = _this.instance.getStatusCode().code;
                if (code === -1) {
                  _this.instance.register();
                }
              },
              onRegister: function (config) {},
              onErrorNotify: function (error) {
                console.log('ali-error', error);
                // 不需要销毁实例错误提示 code
                var remarkErrorNoticeCodes = [5001, 5002, 5003, 5004, 5005, 9009, 9010, 9011, 9012, 8003];
                var errorCode = error.errorCode,
                  errorMsg = error.errorMsg,
                  errorMsgTip = error.errorMsgTip;
                if (errorCode === 7001) {
                  if (['READY', 'BREAK', 'OFFLINE'].includes(errorMsg.userState)) {
                    setTimeout(function () {
                      _this.instance.forceToPrepareSignIn();
                    }, 1000);
                  } else {
                    _this.config.onInstanceStatusChange(false, PLATFORM);
                    _this.config.onRegistrationFailed && _this.config.onRegistrationFailed(PLATFORM, '有其他设备正在通话，请稍后登录');
                  }
                } else {
                  var warnStr = errorMsgTip ? typeof errorMsgTip === 'string' ? errorMsgTip : errorMaps[errorCode] : errorMaps[errorCode];
                  if (errorCode && remarkErrorNoticeCodes.includes(errorCode)) {
                    _this.config.onWarn(warnStr);
                  } else {
                    _this.linkStatus = false;
                    _this.config.onInstanceStatusChange(false, PLATFORM);
                    if (error && error.errorCode === 7007) {
                      _this.config.onClose && _this.config.onClose('browser', PLATFORM, errorMaps[errorCode]);
                      // 被踢下线 销毁实例
                    }
                    _this.config.onRegistrationFailed && _this.config.onRegistrationFailed(PLATFORM, warnStr);
                  }
                }
              },
              onCallComing: function (callDetail) {
                var caller = callDetail.caller,
                  callee = callDetail.callee,
                  jobId = callDetail.jobId;
                var params = {
                  FromNo: caller,
                  ToNo: callee,
                  RecordId: jobId,
                  platform: PLATFORM,
                  phoneType: 1
                };
                // 来电提醒
                _this.config.onShowCommingCall({
                  FromNo: caller,
                  ToNo: callee,
                  RecordId: jobId,
                  platform: PLATFORM,
                  phoneType: 1
                });
                // 添加通话记录
                _this.config.addRecord(params, 'called', PLATFORM);
              },
              onCallDialing: function (callDetail) {
                console.log('callDetail', callDetail);
                var caller = callDetail.caller,
                  callee = callDetail.callee,
                  jobId = callDetail.jobId;
                var params = {
                  FromNo: caller,
                  ToNo: callee,
                  RecordId: jobId,
                  platform: PLATFORM,
                  phoneType: 2
                };
                // 添加通话记录
                _this.config.addRecord(params, 'call', PLATFORM);
              },
              onLogIn: function () {},
              onBreak: function () {},
              onReady: function () {},
              onHangUp: function () {
                _this.config.onHangup(PLATFORM);
              },
              onStatusChange: function (stateDetail) {
                var code = stateDetail.code,
                  context = stateDetail.context;
                // 检测到通话状态，并改变导航右上角的话务状态为【...通话中】
                if (code !== -1 && !_this.linkStatus) {
                  _this.linkStatus = true;
                  _this.config.onInstanceStatusChange(true, PLATFORM);
                }
                /**
                 * 1： 签出— 未登录； 2： 忙碌； 3： 空闲
                 * 4 小休  置忙
                 * 6  振铃
                 * 8  拨号
                 * 9  呼入通话
                 * 10 呼出通话
                 */
                if ([1, 2, 3, 4].includes(code)) {
                  var statusMap = {
                    1: 'logOut',
                    2: 'busy',
                    3: 'free'
                  };
                  _this.config.statusCodeChange(statusMap[code], PLATFORM);
                }
                if (code === 9 || code === 10) {
                  _this.config.onCall(PLATFORM);
                }
                if (code === 8) {
                  _this.config.onCallUp(PLATFORM);
                }
              },
              onCallRelease: function (callDetail) {
                //  通话结束时触发
                // 给后端发布电话释放的状态，需要请求接口
                _this.config.onReleaseCall && _this.config.onReleaseCall(callDetail, PLATFORM);
              }
            });
            return [2 /*return*/];
        }
      });
    });
  };
  // 阿里拨打电话
  CreateAliPlusCall.prototype.call = function (to) {
    if (!to) {
      this.config.onWarn('被叫号码不能为空号！');
      return;
    }
    if (!this.instance) {
      this.config.onWarn('阿里云账户信息缺失！');
      return;
    }
    var status = this.instance.getStatusCode();
    if (status) {
      if (status.code === 1) {
        this.instance.logIn();
      } else if (status.code === 12) {
        this.instance.callRetrieve();
        this.instance.hangUp();
      } else if (status.code === 8) {
        this.instance.hangUp();
      }
    }
    this.instance.call(to, 'auto');
  };
  // 挂断电话
  CreateAliPlusCall.prototype.hangup = function () {
    if (!this.instance || !this.instance.getStatusCode) return;
    var code = this.instance.getStatusCode().code;
    if (code === 6 || code === 8 || code === 9 || code === 10) {
      this.instance.hangUp();
    }
  };
  CreateAliPlusCall.prototype.setConfig = function (config) {
    this.instance && (this.config = Object.assign({}, this.config, config));
  };
  // 接听电话
  CreateAliPlusCall.prototype.answer = function () {
    this.instance.answer();
  };
  // 获取当前的话务状态
  CreateAliPlusCall.prototype.getCallStatus = function () {
    if (this.instance) {
      var code = this.instance.getStatusCode().code;
      console.log('getCallStatus', code);
      var statusMap = {
        1: 'logOut',
        2: 'busy',
        3: 'free',
        4: 'busy',
        6: 'ring',
        8: 'calling',
        9: 'talking',
        10: 'talking'
      };
      return statusMap[code];
    } else {
      return null;
    }
  };
  // 二次拨号
  CreateAliPlusCall.prototype.sendDtmf = function (code) {
    this.instance.sendDtmf(code);
  };
  CreateAliPlusCall.prototype.destroy = function () {
    var _a, _b;
    try {
      console.log('destroy');
      this.config.onClose = undefined;
      this.config.onRegistrationFailed = undefined;
      this.instance && ((_a = this.instance) === null || _a === void 0 ? void 0 : _a.unloadWorkbench) && ((_b = this.instance) === null || _b === void 0 ? void 0 : _b.unloadWorkbench());
      this.instance = null;
    } catch (error) {
      console.log(error);
    }
  };
  return CreateAliPlusCall;
}();
var CreateCall = /** @class */function () {
  function CreateCall(option, instanceType) {
    switch (instanceType) {
      case 'aliyun':
        return new CreateAliCall(option);
      case 'fbocc':
        return new CreateFobccCall(option);
      case 'tengxun':
        return new CreateTengxunCall(option);
      case 'tianrun':
        return new CreateTianrunCall(option);
      case 'aliyunPlus':
        return new CreateAliPlusCall(option);
    }
  }
  return CreateCall;
}();
var checkContainer = function () {
  if (!document.getElementById('webvideo') && !document.getElementById('remoteVideoa')) {
    var fboccEle = document.createElement('div');
    fboccEle.setAttribute('id', 'webvideo');
    var audio = document.createElement('audio');
    audio.setAttribute('id', 'WSringMusic');
    audio.setAttribute('loop', 'loop');
    audio.setAttribute('src', '');
    audio.setAttribute('autoplay', 'autoplay');
    var videoa = document.createElement('video');
    videoa.setAttribute('id', 'remoteVideoa');
    videoa.setAttribute('autoplay', 'autoplay');
    videoa.style.display = 'none';
    var videov = document.createElement('video');
    videov.setAttribute('id', 'remotevideov');
    videov.setAttribute('autoplay', 'autoplay');
    videov.style.display = 'none';
    fboccEle.appendChild(audio);
    fboccEle.appendChild(videoa);
    fboccEle.appendChild(videov);
    document.body.appendChild(fboccEle);
  }
  if (!document.getElementById('callContainer')) {
    var aliEle = document.createElement('div');
    aliEle.setAttribute('id', 'callContainer');
    aliEle.style.display = 'none';
    document.body.appendChild(aliEle);
  }
};
var statusMap = {
  talking: 10,
  ring: 6,
  logOut: 1,
  login: 2,
  busy: 4,
  free: 3,
  hangup: 3,
  calling: 8,
  outLine: 13
};
var BrowserCall = /** @class */function () {
  function BrowserCall(callProps) {
    var _this = this;
    var _a;
    this.callcenterType = 0; // 用户 通话平台 类型 2 ali 6 ali / fbocc
    this.callConfigObj = {}; // 通话参数
    this.activeCallType = ''; // 当前使用通话平台 ali / fbocc
    this.environment = '';
    this.otherOriginClient = false;
    this.paramsCallConfig = {};
    this.isOnline = true;
    this.callInstances = {
      aliyunInstance: null,
      fboccInstance: null,
      tengxunInstance: null,
      tianrunInstance: null,
      aliyunPlusInstance: null
    }; // 通话实例 ali / fbocc / tengxun
    this.platformStatus = null; // 通话平台状态
    this.instanceStatus = {
      aliyun: null,
      fbocc: null,
      tengxun: null,
      tianrun: null,
      aliyunPlus: null
    };
    this.callCheck = function (platform) {
      var status = platform ? _this.instanceStatus[platform] : _this.platformStatus;
      if (status === null) {
        _this.config.onWarn('请先配置话务系统再拨打电话！');
        return false;
      }
      if (status === 'logOut' || status === null) {
        _this.config.onWarn('请先签入再拨打电话！');
        return false;
      }
      if (status === 'busy') {
        _this.config.onWarn('请先置闲再拨打电话！');
        return false;
      }
      if (status === 'calling') {
        _this.config.onWarn('正在呼叫请通话结束后再拨打');
        return false;
      }
      if (status === 'talking') {
        _this.config.onWarn('正在通话请通话结束后再拨打');
        return false;
      }
      return true;
    };
    this.config = callProps.config;
    this.userInfo = callProps.params.userInfo;
    this.paramsCallConfig = callProps.params.callConfig;
    this.environment = callProps.environment;
    this.otherOriginClient = (_a = callProps.otherOriginClient) !== null && _a !== void 0 ? _a : false;
    this.initContainer();
    this.initMedia(callProps);
    window.addEventListener('offline', function () {
      _this.isOnline = false;
      _this.config.onNetChange && _this.config.onNetChange(0);
      _this.statusChange('outLine', _this.defaultCallType);
      // this.handleOffline();
    });
    window.addEventListener('online', function () {
      _this.isOnline = true;
      _this.config.onNetChange && _this.config.onNetChange(1);
      var defaultInstance = _this.getDefaultInstance();
      if (defaultInstance) {
        var newStatus = defaultInstance === null || defaultInstance === void 0 ? void 0 : defaultInstance.getCallStatus();
        if (newStatus) {
          _this.statusChange(newStatus, _this.defaultCallType);
          return;
        }
      }
      _this.statusChange('logOut', _this.defaultCallType);
    });
    window.addEventListener('unload', function () {
      _this.hangup();
    });
  }
  // 未获取到声卡权限， 获取要注册默认话务
  BrowserCall.prototype.getConfigDefaultPlatform = function (callConfig) {
    var defaultKey;
    var keys = Object.keys(callConfig);
    keys.forEach(function (key) {
      var _a;
      if (key && ((_a = callConfig[key]) === null || _a === void 0 ? void 0 : _a.isDefault)) {
        defaultKey = key;
      }
    });
    return defaultKey;
  };
  // 检查麦克风权限， 获取不到则话务注册失败
  BrowserCall.prototype.initMedia = function (callProps) {
    var _this = this;
    navigator.mediaDevices.getUserMedia({
      audio: true
    }).then(function () {
      _this.init(callProps.params);
    })["catch"](function (err) {
      var defaultPlatform = _this.getConfigDefaultPlatform(callProps.params.callConfig);
      _this.config.onRegistrationFailed && _this.config.onRegistrationFailed(defaultPlatform, '麦克风权限获取失败，请检查麦克风是否启用');
    });
  };
  BrowserCall.prototype.initContainer = function () {
    // 容器校验 不存在新增
    checkContainer();
  };
  BrowserCall.prototype.init = function (query) {
    var _this = this;
    // 新链接需要 实例化 哪几个通话平台 分别处理
    var callConfig = query.callConfig,
      userInfo = query.userInfo,
      fboccInfo = query.fboccInfo;
    this.userInfo = userInfo;
    // 通话参数、通话类型 处理
    this.callConfigObj = callConfig;
    // this.callcenterType = handleCallType(this.callConfigObj);
    // 根据配置 初始化平台
    // @ts-ignore
    var instanceKeys = Object.keys(this.callConfigObj);
    // const { aliyun, fbocc } = this.callConfigObj;
    // const canCallByAli = aliyun ? aliyun.callExt && aliyun.account && aliyun.password : false;
    instanceKeys.forEach(function (key) {
      // @ts-ignore
      _this.createCallInstance(userInfo, _this.callConfigObj[key], key, fboccInfo);
    });
  };
  // 创建呼叫实例
  BrowserCall.prototype.createCallInstance = function (userInfo, config, instanceType, fboccInfo) {
    var _this = this;
    var option = {
      userInfo: __assign({
        environment: this.environment,
        otherOriginClient: this.otherOriginClient
      }, userInfo),
      config: config,
      fboccInfo: fboccInfo,
      onCall: function (platform) {
        // 通话中
        _this.statusChange('talking', platform);
        _this.config.onCall(platform);
      },
      onCallUp: function (platform) {
        // 拨号中
        _this.statusChange('calling', platform);
        _this.config.onCallUp();
      },
      addRecord: function (params, type, platform) {
        // 添加通话记录
        _this.config.addRecord(params, type, platform);
      },
      onHangup: function (platform) {
        // 挂断
        _this.statusChange('hangup', platform);
        _this.config.onHangup(platform);
      },
      onShowCommingCall: function (args) {
        _this.statusChange('ring', args.platform);
        // 来电通知
        _this.config.onShowCommingCall(args);
      },
      onClose: function (type, platform, msg) {
        _this.config.onClose && _this.config.onClose(type, platform, msg);
        _this.config.onStatusChange && _this.config.onStatusChange(14, platform);
        //  被下线 对应的实例 及状态 设为 null
        // this.callInstances.aliyunInstance = null
        _this.handleDestroy(platform);
      },
      onReleaseCall: function (data, platform) {
        // ali yun 通话结束
        // aliyun 给后端发布电话释放的状态，需要请求接口
        _this.config.onReleaseCall && _this.config.onReleaseCall(data, platform);
      },
      onWarn: function (msg, type) {
        _this.config.onWarn(msg, type);
      },
      statusCodeChange: function (status, platform) {
        // 签入、签出、置闲、置忙
        _this.statusChange(status, platform);
      },
      // 实例初始化状态
      onInstanceStatusChange: function (status, type) {
        // this.mainId &&
        //     ipcRenderer.sendTo(this.mainId, UPDATE_INSTANCE_STATUS, {
        //         userId: this.userInfo?.userId,
        //         updateInfo: JSON.stringify(updateInfo),
        //     });
      },
      onRegistrationFailed: function (platfrom, msg) {
        _this.config.onRegistrationFailed && _this.config.onRegistrationFailed(platfrom, msg);
        _this.handleDestroy(platfrom);
      },
      onTokenOutDate: function (platfrom) {
        var _a, _b;
        // fbocc token 过期  重新请求
        platfrom === 'fbocc' && _this.config.onFobccTokenOutDate && _this.config.onFobccTokenOutDate();
        ((_a = _this.config) === null || _a === void 0 ? void 0 : _a.onTokenOutDate) && ((_b = _this.config) === null || _b === void 0 ? void 0 : _b.onTokenOutDate(platfrom));
      },
      onCallFail: function (msg, platfrom) {
        _this.config.onCallFail && _this.config.onCallFail(msg, platfrom);
      }
    };
    var instance = new CreateCall(option, instanceType);
    config.isDefault && (this.defaultCallType = instanceType);
    switch (instanceType) {
      case 'aliyun':
        this.callInstances.aliyunInstance = instance;
        break;
      case 'fbocc':
        this.callInstances.fboccInstance = instance;
        break;
      case 'tengxun':
        this.callInstances.tengxunInstance = instance;
        break;
      case 'tianrun':
        this.callInstances.tianrunInstance = instance;
        break;
      case 'aliyunPlus':
        this.callInstances.aliyunPlusInstance = instance;
        break;
    }
  };
  // 被下线 对应的实例 及状态 设为 null
  BrowserCall.prototype.handleDestroy = function (platform) {
    var _a, _b, _c, _d, _e;
    this.defaultCallType === platform && (this.platformStatus = null);
    switch (platform) {
      case 'aliyun':
        (_a = this.callInstances.aliyunInstance) === null || _a === void 0 ? void 0 : _a.destroy();
        this.callInstances.aliyunInstance = null;
        this.instanceStatus.aliyun = null;
        break;
      case 'fbocc':
        (_b = this.callInstances.fboccInstance) === null || _b === void 0 ? void 0 : _b.destroy();
        this.callInstances.fboccInstance = null;
        this.instanceStatus.fbocc = null;
        break;
      case 'tengxun':
        (_c = this.callInstances.tengxunInstance) === null || _c === void 0 ? void 0 : _c.destroy();
        this.callInstances.tengxunInstance = null;
        this.instanceStatus.tengxun = null;
        break;
      case 'tianrun':
        (_d = this.callInstances.tianrunInstance) === null || _d === void 0 ? void 0 : _d.destroy();
        this.callInstances.tianrunInstance = null;
        this.instanceStatus.tianrun = null;
        break;
      case 'aliyunPlus':
        (_e = this.callInstances.aliyunPlusInstance) === null || _e === void 0 ? void 0 : _e.destroy();
        this.callInstances.aliyunPlusInstance = null;
        this.instanceStatus.aliyunPlus = null;
        break;
    }
  };
  // offline  destroy
  BrowserCall.prototype.handleOffline = function () {
    this.callInstances.aliyunInstance && this.handleDestroy('aliyun');
    this.callInstances.fboccInstance && this.handleDestroy('fbocc');
    this.callInstances.tengxunInstance && this.handleDestroy('tengxun');
    this.callInstances.tianrunInstance && this.handleDestroy('tianrun');
    this.callInstances.aliyunPlusInstance && this.handleDestroy('aliyunPlus');
  };
  BrowserCall.prototype.statusChange = function (status, platform) {
    this.instanceStatus[platform] = status;
    this.defaultCallType === platform && (this.platformStatus = status);
    if (status) {
      var sendStatus = this.getDefaultInstance(platform) ? statusMap[status] : 1;
      this.config.onStatusChange(sendStatus, platform);
    }
  };
  // 签入 /签出
  BrowserCall.prototype.switchStatus = function (status) {
    if (this.checkHasInstance()) {
      Object.values(this.callInstances).forEach(function (instance) {
        instance && instance.switchStatus(status);
      });
    }
  };
  // aliplus logout
  BrowserCall.prototype.logoutAliPlus = function () {
    this.callInstances.aliyunPlusInstance && this.callInstances.aliyunPlusInstance.switchStatus(2);
  };
  BrowserCall.prototype.reportCallInfo = function (callee, plat) {
    var platform = plat || this.defaultCallType;
    var callExtStr = platform === 'tengxun' ? 'kfext' : 'callExt';
    var callExt = this.paramsCallConfig[platform][callExtStr] || '';
    var typse = {
      tengxun: 4,
      aliyunPlus: 2,
      aliyun: 2,
      fbocc: 6,
      tianrun: 3
    };
    var xhr = new XMLHttpRequest();
    var url = "https://" + this.environment + "apigateway.gaodun.com/usopp/api/v1/call-record/save-call-log";
    var params = {
      userId: this.userInfo.userId,
      callCenterType: typse[platform],
      callExt: callExt,
      callId: '',
      answerNo: callee,
      remark: "\u6D4F\u89C8\u5668\u8C03\u7528" + platform + "\u53D1\u8D77\u547C\u53EB--" + Date.now()
    };
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status >= 200 && xhr.status < 300 || xhr.status === 304) {
          var res = JSON.parse(xhr.response);
          console.log(res);
        }
      }
    };
    xhr.open('post', url, true);
    xhr.setRequestHeader('Content-type', 'application/json');
    xhr.send(JSON.stringify(params));
  };
  // 拨号
  BrowserCall.prototype.call = function (callee, platform) {
    console.log('call callee', callee);
    if (this.callCheck()) {
      var callInstance = this.getDefaultInstance(platform);
      if (callInstance) {
        this.reportCallInfo(callee, platform);
        callInstance.call(callee);
      } else {
        this.config.onWarn('通话不存在，请检查通话配置重新实例化');
      }
    }
    // }
  };
  // 获取通话平台实例 不传参数 获取默认
  BrowserCall.prototype.getDefaultInstance = function (platform) {
    switch (platform || this.defaultCallType) {
      case 'aliyun':
        return this.callInstances.aliyunInstance;
      case 'fbocc':
        return this.callInstances.fboccInstance;
      case 'tengxun':
        return this.callInstances.tengxunInstance;
      case 'tianrun':
        return this.callInstances.tianrunInstance;
      case 'aliyunPlus':
        return this.callInstances.aliyunPlusInstance;
      default:
        return null;
    }
  };
  // 验证实例是否存在 所有 默认
  BrowserCall.prototype.checkHasInstance = function () {
    var hasInstance = false;
    Object.values(this.callInstances).forEach(function (instance) {
      if (instance) {
        hasInstance = true;
      }
    });
    if (!hasInstance) {
      //  所有实例 均不存在
      this.config.onWarn('通话不存在或已下线，请先实例化通话');
    }
    return hasInstance;
  };
  // 切换默认平台
  BrowserCall.prototype.setDefaultInstance = function (platform) {
    if (this._getInstanceStatus(platform)) {
      this.defaultCallType = platform;
      this.platformStatus = this.instanceStatus[platform]; // 默认平台状态切换
    } else {
      this.config.onWarn('切换的平台未配置或不存在');
    }
  };
  // 获取通话平台状态  没参数 取默认平台   平台为未配置 返回 0
  BrowserCall.prototype._getInstanceStatus = function (platform) {
    return platform ? statusMap[this.instanceStatus[platform] || 'noSet'] : statusMap[this.platformStatus || 'noSet'];
  };
  BrowserCall.prototype.getInstanceStatus = function (platform) {
    var status = this._getInstanceStatus();
    this.config.onGetPlatformStatus && this.config.onGetPlatformStatus(status);
  };
  BrowserCall.prototype.hangup = function () {
    // if (this.checkHasInstance()) {
    Object.values(this.callInstances).forEach(function (instance) {
      instance && instance.hangup();
    });
    // }
  };
  // 接听电话
  BrowserCall.prototype.handleAnswer = function () {
    if (this.checkHasInstance()) {
      Object.values(this.callInstances).forEach(function (instance) {
        instance && instance.answer();
      });
    }
  };
  BrowserCall.prototype.resetFboccToken = function (token) {
    if (this.callInstances.fboccInstance) {
      this.callInstances.fboccInstance.resetFboccToken(token);
    }
  };
  BrowserCall.prototype.resetToken = function (token, platform) {
    switch (platform) {
      case 'fbocc':
        this.resetFboccToken(token);
        break;
      case 'tengxun':
        if (this.callInstances.tengxunInstance) {
          this.callInstances.tengxunInstance.resetToken(token);
        }
        break;
    }
  };
  // 二次拨号
  BrowserCall.prototype.sendDtmf = function (code, platform) {
    var callInstance = this.getDefaultInstance(platform);
    if (callInstance) {
      callInstance.sendDtmf(code);
    } else {
      this.config.onWarn('通话不存在，请检查通话配置重新实例化');
    }
  };
  // 设置 config
  BrowserCall.prototype.setConfig = function (config) {
    this.config = config;
    Object.values(this.callInstances).forEach(function (instance) {
      instance && instance.setConfig(config);
    });
  };
  BrowserCall.prototype.destroy = function () {
    Object.values(this.callInstances).forEach(function (instance) {
      instance && instance.destroy();
    });
    // this.callInstances.fboccInstance && this.callInstances.fboccInstance.destroy();
    // this.callInstances.aliyunInstance && this.callInstances.aliyunInstance.destroy();
  };
  return BrowserCall;
}();
export default BrowserCall;